<script setup>
import { ref, computed } from 'vue';
import { Head, Link, useForm, usePage } from '@inertiajs/vue3';
import Checkbox from '@/Components/Checkbox.vue';
import InputError from '@/Components/InputError.vue';
import InputLabel from '@/Components/InputLabel.vue';
import TextInput from '@/Components/TextInput.vue';
import MainButton from '@/Components/MainButton.vue';
import ShowPasswordToggle from '@/Components/ShowPasswordToggle.vue';
import NewFooter from '@/Components/NewFooter.vue';

import Rectangle4 from '../../../../public/images/PurpleSmoke2.jpg';
import Registration from '../../../../public/images/GirlsWhispering.png';
import messagingFrame from '../../../../public/images/Messaging.png';

const form = useForm({
  name: '',
  email: '',
  password: '',
  password_confirmation: '',
  terms: false
});

const submit = () => {
  form.post(route('register'), {
    onFinish: () => form.reset('password', 'password_confirmation')
  });
};

const showPassword = ref(false);
const { url } = usePage();
/*
if (url !== '/register?p=beta') {
  location.href = '/waitlist';
}
  */

const currentView = computed(() => {
  if (url === '/register?p=messaging') {
    return 'messaging';
  } else if (url === '/register?p=profile1') {
    return 'profile1';
  } else if (url === '/register?p=profile2') {
    return 'profile2';
  } else if (url === '/register?p=profile3') {
    return 'profile3';
  } else {
    return 'default';
  }
});

const showMessagingFrame = computed(() => currentView.value === 'messaging');
const showProfileFrame1 = computed(() => currentView.value === 'profile1');
const showProfileFrame2 = computed(() => currentView.value === 'profile2');
const showProfileFrame3 = computed(() => currentView.value === 'profile3');
const showDefaultImage = computed(() => currentView.value === 'default');
</script>

<template>

  <Head title="Register" />

  <div class="flex flex-col bg-white">
    <div class="flex  min-h-[300px] w-full flex-col md:flex-row">
      <!-- <div class="flex h-[75%] md:relative md:h-full md:w-2/5">
          <img :src="Rectangle4" alt="" class="w-full h-full" /> -->
      <div class="flex h-[300px] min-h-[100] sm:flex sm:items-center sm:justify-center md:relative md:h-full md:w-2/5">
        <img
          :src="Rectangle4"
          alt=""
          class="object-cover w-full h-full"
          s
        />
        <!-- <div
            v-if="showMessagingFrame"
            class="absolute inset-0 mx-auto flex w-[70%] items-center justify-center rounded-2xl border-2 border-gray-300 bg-purple-50 bg-opacity-30"
          >
            <img :src="messagingFrame" alt="Messaging Frame" class="" />
          </div> -->
        <div
          v-if="showMessagingFrame"
          class="absolute inset-0 mx-auto mt-36 flex !h-44 items-center justify-center md:top-[40%] md:mt-0"
          style="width: 70%; height: fit-content"
        >
          <img
            :src="messagingFrame"
            alt="Messaging Frame"
            class="rounded-md w-96"
          />
        </div>

        <!-- <div
            v-if="showProfileFrame"
            class="absolute justify-center border-gray-300 border-1 bg-purple-80 top-1 rounded-2xl bg-opacity-30 md:-right-20 md:left-auto md:top-10 lg:-right-0"
          > -->

        <div
          v-if="showProfileFrame1"
          class="absolute inset-0 flex items-center justify-center mx-auto rounded-md -mt-96 md:mt-0"
        >
          <img
            src="/images/dummy/profiles/JohnRyderScreenshot.jpeg"
            alt="Profile Frame"
            class="object-contain h-1/4 md:h-full"
            width="70%"
          />
        </div>
        <div
          v-if="showProfileFrame2"
          class="absolute inset-0 flex items-center justify-center mx-auto rounded-md -mt-96 md:mt-0"
        >
          <img
            src="/images/dummy/profiles/SamanthaBlackScreenshot.png"
            alt="Profile Frame"
            class="object-contain h-1/4 md:h-full"
            width="70%"
          />
        </div>
        <div
          v-if="showProfileFrame3"
          class="absolute inset-0 flex items-center justify-center mx-auto rounded-md -mt-96 md:mt-0"
        >
          <img
            src="/images/dummy/profiles/EmberSkyeScreenshot.png"
            alt="Profile Frame"
            class="object-contain h-1/4 md:h-full"
            width="70%"
          />
        </div>
        <div
          v-else-if="showDefaultImage"
          class="absolute py-16 -translate-x-1/2 -translate-y-1/2 left-1/2 top-32 h-80 w-60 rounded-2xl md:top-1/2 md:py-0"
        >
          <img
            :src="Registration"
            alt="Registration Female"
            class="h-full w-full !rounded-xl border border-purple-400 object-cover opacity-50"
          />
        </div>
      </div>

      <!-- Right Side Form -->
      <div class="p-4 bg-white md:h-full md:w-3/5">
        <h1 class="mt-20 mb-6 text-4xl font-semibold font-title">
          Register Account
        </h1>
        <form @submit.prevent="submit">
          <!-- Name Input -->
          <div>
            <InputLabel
              for="name"
              value="Name"
            />
            <TextInput
              id="name"
              v-model="form.name"
              type="text"
              class="block w-full mt-1"
              required
              autofocus
              autocomplete="name"
            />
            <InputError
              class="mt-2"
              :message="form.errors.name"
            />
          </div>

          <!-- Email Input -->
          <div class="mt-4">
            <InputLabel
              for="email"
              value="Email"
            />
            <TextInput
              id="email"
              v-model="form.email"
              type="email"
              class="block w-full mt-1"
              required
              autocomplete="username"
            />
            <InputError
              class="mt-2"
              :message="form.errors.email"
            />
          </div>

          <!-- Password Input -->
          <div class="mt-4">
            <InputLabel
              for="password"
              value="Password"
            />
            <TextInput
              id="password"
              v-model="form.password"
              :type="showPassword ? 'text' : 'password'"
              class="block w-full mt-1"
              required
              autocomplete="new-password"
            />
            <ShowPasswordToggle v-model="showPassword" />
            <InputError
              class="mt-2"
              :message="form.errors.password"
            />
          </div>

          <!-- Password Confirmation -->
          <div class="mt-4">
            <InputLabel
              for="password_confirmation"
              value="Confirm Password"
            />
            <TextInput
              id="password_confirmation"
              v-model="form.password_confirmation"
              :type="showPassword ? 'text' : 'password'"
              class="block w-full mt-1"
              required
              autocomplete="new-password"
            />
            <ShowPasswordToggle v-model="showPassword" />
            <InputError
              class="mt-2"
              :message="form.errors.password_confirmation"
            />
          </div>

          <!-- Terms Checkbox -->
          <div
            v-if="$page.props.jetstream.hasTermsAndPrivacyPolicyFeature"
            class="mt-4"
          >
            <InputLabel for="terms">
              <div class="flex items-center">
                <Checkbox
                  id="terms"
                  v-model:checked="form.terms"
                  name="terms"
                  required
                />

                <div class="ms-2">
                  I agree to the
                  <Link
                    target="_blank"
                    :href="route('terms-of-service')"
                    class="text-sm text-gray-400 underline transition duration-300 rounded-md hover:text-orange-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 dark:focus:ring-offset-gray-800"
                  >
                  Terms of Service
                  </Link>
                </div>
              </div>
              <InputError
                class="mt-2"
                :message="form.errors.terms"
              />
            </InputLabel>
          </div>

          <!-- Submit Button -->
          <div class="flex flex-col w-full mt-4">
            <MainButton
              class="w-full justify-center !rounded-full"
              :class="{ 'opacity-25': form.processing }"
              :disabled="form.processing"
            >
              <span class="text-center">Sign Up</span>
            </MainButton>
            <Link
              :href="route('login')"
              class="mt-2 text-sm transition duration-200 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 dark:hover:text-gray-100 dark:focus:ring-offset-gray-800"
            >
            Already registered?
            </Link>
          </div>
        </form>
      </div>
    </div>

    <NewFooter />
  </div>
</template>
